import Home from './Home'
import Register from './Register'
import LegalTec from './LegalTec'
import LegalEULA from './LegalEULA'
import LegalTecB from './LegalTecB'
import CookieP from './CookieP'
import LegalEULACoupon from './LegalEULACoupon'
import RegisterFidel from './RegisterFidel'
import TimeLine from './TimeLine'

export default{
  Home: Home,
  Register: Register,
  LegalTec: LegalTec,
  LegalTecB: LegalTecB,
  CookieP: CookieP,
  LegalEULA: LegalEULA,
  LegalEULACoupon: LegalEULACoupon,
  RegisterFidel: RegisterFidel,
  TimeLine: TimeLine
}



// WEBPACK FOOTER //
// ./src/components/frontend/components.js